// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerMux" + "." + "2e013591" + ".chunk.js";
};